import {
  setWrapperClass,
  setActiveStep,
  setInputTerm,
  setActiveTab,
  setSuggestions,
  setInitialCategories,
  setCategoriesLevel,
  updateSelectedCategory,
  cleanCategories,
  setSearch,
  unsetSearch,
  setProductsLoading,
  unsetProductsLoading,
  setProducts,
  setUserDetails,
  setSelectedProduct,
  setproductRegGuid,
  setIsConfirmation,
  setHasMarketingConsent,
} from '@/product-registration/context/action-creators';

export default dispatch => ({
  setWrapperClass: payload => dispatch(setWrapperClass(payload)),
  setActiveStep: payload => dispatch(setActiveStep(payload)),
  setInputTerm: payload => dispatch(setInputTerm(payload)),
  setActiveTab: payload => dispatch(setActiveTab(payload)),
  setSuggestions: payload => dispatch(setSuggestions(payload)),
  setInitialCategories: payload => dispatch(setInitialCategories(payload)),
  setCategoriesLevel: payload => dispatch(setCategoriesLevel(payload)),
  updateSelectedCategory: payload => dispatch(updateSelectedCategory(payload)),
  cleanCategories: payload => dispatch(cleanCategories(payload)),
  setSearch: payload => dispatch(setSearch(payload)),
  unsetSearch: () => dispatch(unsetSearch()),
  setProductsLoading: () => dispatch(setProductsLoading()),
  unsetProductsLoading: () => dispatch(unsetProductsLoading()),
  setProducts: payload => dispatch(setProducts(payload)),
  setUserDetails: payload => dispatch(setUserDetails(payload)),
  setSelectedProduct: payload => dispatch(setSelectedProduct(payload)),
  setproductRegGuid: payload => dispatch(setproductRegGuid(payload)),
  setIsConfirmation: payload => dispatch(setIsConfirmation(payload)),
  setHasMarketingConsent: payload => dispatch(setHasMarketingConsent(payload)),
});
